import React, { useEffect } from 'react'
import TabComponent from '../../component/TabComponent'
import Branchs from './branchs'
import BudgetYears from './budgetYears'
import ChangePassword from './changePassword'
import DiscountSale from './discountSale'
import Employee from './employee'
import Groups from './groups'
import Item from './item'
import Role from './role'
import Wherehouse from './wherehouse'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Material from './material'

export default function Setting() {
  const { profile } = useSelector(state => state.profile)

  const location = useLocation()
  const navigate = useNavigate()

  // const dataTabs = [
  //   {
  //     title: 'ประเภท, พันธ์ุข้าว & ชนิดของพันธุ์ข้าว',
  //     page: <Groups />,
  //     url: '/setting/category',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Category.Read')?.Permit
  //   },
  //   {
  //     title: 'รายละเอียดเมล็ดพันธุ์ข้าว',
  //     page: <Item />,
  //     url: '/setting/item',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Item.Read')?.Permit
  //   },
  //   {
  //     title: 'ศูนย์เมล็ดพันธุ์ข้าว',
  //     page: <Branchs />,
  //     url: '/setting/branchs',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Branch.Read')?.Permit
  //   },
  //   {
  //     title: 'โรงเก็บ',
  //     page: <Wherehouse />,
  //     url: '/setting/wherehouse',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Warehouse.Read')?.Permit
  //   },
  //   {
  //     title: 'วัสดุ',
  //     page: <Material />,
  //     url: '/setting/material',
  //     Permit: true
  //   },
  //   {
  //     title: 'กลุ่มผู้ใช้งาน',
  //     page: <Role />,
  //     url: '/setting/role',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Employee.Read')?.Permit
  //   },
  //   {
  //     title: 'ผู้ใช้งานระบบ',
  //     page: <Employee />,
  //     url: '/setting/employee',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Employee.Read')?.Permit
  //   },
  //   {
  //     title: 'ส่วนลดการขาย',
  //     page: <DiscountSale />,
  //     url: '/setting/discount-sale/list',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'Discount.Read')?.Permit
  //   },
  //   {
  //     title: 'ปีงบประมาณ',
  //     page: <BudgetYears />,
  //     url: '/setting/budget-years',
  //     Permit: profile?.Permissions?.find((x) => x?.Action === 'BudgetYear.Read')?.Permit
  //   },
  //   {
  //     title: 'เปลี่ยนรหัสผ่าน',
  //     page: <ChangePassword />,
  //     url: '/setting/change-password',
  //     Permit: true
  //   },
  // ]
  // useEffect(() => {
  //   if(location.pathname === '/setting'){
  //     navigate(dataTabs[0].url)
  //   }
  // },[location.pathname])
  return (
    <div style={{ padding: '10px 30px' }}>
      {/* <TabComponent dataTabs={dataTabs} /> */}
    </div>
  )
}
